<script setup lang="ts">

import {watch} from "vue";

const model = defineModel<string | number | null>()

defineProps<{
    id: string,
    label?: string,
    disabled?: boolean,
    required?: boolean,
    error?: string,
}>()

const emit = defineEmits(['clearError'])

watch(model, () => emit('clearError'))

</script>

<template>
    <div class="space-y-2">
        <label :for="id" class="w-full">
            {{ label }}<span v-if="required" class="text-primary ml-2">*</span>
        </label>

        <div class="relative h-30 flex items-center border border-solid rounded duration-150 hover:bg-gray-accent group"
             :class="error ? 'border-red' : 'border-gray-light'"
        >
            <input :id="id" v-model="model" :disabled="disabled"
                   class="border-none rounded w-full h-8 p-4 text-sm text-dark grow duration-150 outline-none focus:outline-none hover:bg-gray-accent"
                   :class="disabled ? 'bg-gray-accent' : 'bg-white'"
            />
        </div>

        <div v-if="error" class="text-xs text-red">{{ error }}</div>
    </div>
</template>
